module.exports = __webpack_public_path__ + "img/appIcon-ui--tableSortUp.7fd6e0c3.svg";